/// <reference path="../_references.ts"/>

module App.Customer {

	import PaymentType = App.Payment.PaymentType;
	import ServiceRequestType = App.Appointments.ServiceRequestType;
	import LeadSource = App.Appointments.LeadSource;
	import Salesman = App.Appointments.Salesman;
	import ServicePlan = App.Appointments.ServicePlan;
	import FinancePlan = App.Appointments.FinancePlan;
	import Department = App.Appointments.Department;
	import Package = App.PriceGuide.Package;
	import ServiceNote = App.Appointments.ServiceNote;
	import Location = App.DispatchService.Location;

	export class Address {
		id: number = null;
		street: string = null;
		street_two: string = "";
		city: string = null;
		state: string = null;
		zip: string = null;
		latitude: string = null;
		longitude: string = null;
		location: Location = null;
		able_to_bill: number = 0;
		address_components: AddressComponents = null;
		address: string = null;

		constructor() {

		}
	}

	export class AddressComponents {
		streetNum: string = null;
		streetName: string = null;
		city: string = null;
		postalCode: string = null;
		state: string = null;
		latitude: number = null;
		longitude: number = null;

		constructor() {

		}
	}

	export class AddressComponent {
		long_name: string = null;
		short_name: string = null;
		types: string[] = null;

		constructor() {

		}
	}

	export type DispatchCode = {
		id: number;
		name: string;
		department: Department;
	}

	export interface ICustomer {
		id: number;
		priority: number;
		full_name: string;
		company_name: string;
		service_addresses: Array<Address>;
		first_name: string;
		last_name: string;
		contract_rate: boolean;
		emails: Array<Email>;
		phone_numbers: Array<PhoneNumber>;
		billing_addresses: Array<Address>;
		able_to_bill: number;
		notes: string;
		rate_type: number;
		can_show_financing: boolean;
	}

	export class Customer implements ICustomer {
		id: number = null;
		priority: number = 3;
		full_name: string = null;
		company_name: string = null;
		service_addresses: Array<Address> = [];
		first_name: string = null;
		last_name: string = null;
		contract_rate: boolean = false;
		emails: Array<Email> = [];
		phone_numbers: Array<PhoneNumber> = [];
		billing_addresses: Array<Address> = [];
		able_to_bill: number = 0;
		notes: string;
		rate_type: number = null;
		can_show_financing: boolean = true;

		constructor() { }

		addServiceAddress(address?: Address) {
			this.service_addresses.push(address || new Address());
		}

		addBillingAddress(address?: Address) {
			this.billing_addresses.push(address || new Address());
		}
	}

	export class Email {
		id: number = null;
		email: string = null;
		label: string = null;
		marketing: boolean = true;
	}

	export class PhoneNumber {
		id?: number = null;
		number: string = null;
		label?: string = null;
		send_text: boolean = true;
	}

	export class ServiceRequest {
		id?: number;
		latest_invoice_id: number;
		last_sent_recommendation?: {['id']: number};
		service_address: number;
		service_request_type: ServiceRequestType;
		service_request_status: number;
		promised_date?: string;
		promised_time?: string;
		description?: string;
		payment_type: PaymentType;
		lead_source: LeadSource;
		salesman: Salesman;
		service_plan?: ServicePlan;
		finance_plan?: FinancePlan;
		notes?: ServiceNote;
		appointments: Appointment[];
		dispatch_code: number;
		department: number;
		technician?: number;
		packages?: Package[];
		customer: number|ICustomer;
		amount_due?: string;
		total?: string;
		after_hours: boolean;
		create_appointment: number;

		constructor() {

		}
	}

	export type Appointment = {
		id: number;
		service_request: number;
		scheduled_date: string; // YYYY-MM-DD
		scheduled_time: string; // HH:mm
		technician: number;
	}
}
